<template>
    <v-sheet>
        <v-row class="ma-n8" align="stretch">
            <v-col class="pa-8" cols="auto" style="width: 310px">
                <v-card outlined class="fill-height pa-40">
                    <v-layout fill-height justify-center align-center style="gap: 40px">
                        <v-layout column align-center style="gap: 8px">
                            <span> 참여 회원수 </span>
                            <b> {{ (statistic?.employees?.count || 0).format() }}명</b>
                        </v-layout>

                        <v-layout column align-center style="gap: 8px">
                            <span> 참여 기업수 </span>
                            <b> {{ (statistic?.employers?.count || 0).format() }}명</b>
                        </v-layout>
                    </v-layout>
                </v-card>
            </v-col>
            <v-col class="pa-8">
                <v-card outlined class="fill-height pa-40">
                    <v-layout column style="gap: 24px">
                        <v-row class="ma-n12" justify="center">
                            <template v-for="item in items_chart">
                                <v-col lg="auto" class="pa-12" :key="item.title">
                                    <statistic-chart v-bind="item" />
                                </v-col>
                            </template>
                        </v-row>
                        <v-row class="ma-n4">
                            <template v-for="{ title, mode } in items_ranks">
                                <v-col class="pa-4" :key="title">
                                    <statistic-ranks v-bind="{ _program, title, mode }">
                                        <template #activator="{ attrs, on }">
                                            <v-btn outlined block color="primary" v-bind="attrs" v-on="on">
                                                <span> {{ title }} 바로가기 </span>
                                            </v-btn>
                                        </template>
                                    </statistic-ranks>
                                </v-col>
                            </template>
                        </v-row>
                    </v-layout>
                </v-card>
            </v-col>
        </v-row>
    </v-sheet>
</template>

<script>
import api from "@/api";
import { mapGetters } from "vuex";
import StatisticChart from "./statistic/statistic-chart.vue";
import StatisticRanks from "./statistic/statistic-ranks.vue";

export default {
    components: {
        StatisticChart,
        StatisticRanks,
    },
    props: {
        isTabActive: { type: Boolean, default: false },
    },
    data: () => ({
        statistic: {},

        loading: false,
    }),
    computed: {
        ...mapGetters("expo", ["_program"]),
        items_chart() {
            return [
                {
                    title: "매칭건수",
                    total: this.statistic.matchings?.total || 0,
                    count: this.statistic.matchings?.count || 0,
                },
                {
                    title: "매칭완료",
                    total: this.statistic.matchings?.count || 0,
                    count: this.statistic.matchings?.grant?.true || 0,
                },
                {
                    title: "매칭거부",
                    total: this.statistic.matchings?.count || 0,
                    count: this.statistic.matchings?.grant?.false || 0,
                },
                {
                    title: "채용완료",
                    total: this.statistic.matchings?.grant?.true || 0,
                    count: this.statistic.matchings?.hired?.true || 0,
                },
                {
                    title: "미채용",
                    total: this.statistic.matchings?.grant?.true || 0,
                    count: this.statistic.matchings?.hired?.false || 0,
                },
            ];
        },
        items_ranks() {
            return [
                { title: "매칭 기업체 순위", mode: "matched" },
                { title: "면접 기업체 순위", mode: "granted" },
                { title: "채용 기업체 순위", mode: "success" },
            ];
        },
    },
    methods: {
        init() {
            this.search();
        },

        async search() {
            if (!this.isTabActive) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                const { statistic } = await api.v1.expo.programs.getStatistic({ _id: this._program });
                this.statistic = statistic;
            } finally {
                if (this.loading) this.loading = false;
            }
        },
    },
    watch: {
        _program() {
            this.init();
        },
        isTabActive() {
            this.search();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style>
</style>